export const STATUS_NORMAL = 1;
export const STATUS_CANCEL = 2;
export const STATUS_CANCELBAD = 3;
export const STATUS_CANCELOFFICE = 4;
export const STATUS_CANCELHIME1 = 5;
export const STATUS_CANCELHIME2 = 6;
export const STATUS_CANCELMISC = 9;

export const CancelStatusNameMap = {
  [STATUS_NORMAL]: 'なし',
  [STATUS_CANCEL]: 'ｷｬﾝｾﾙ',
  [STATUS_CANCELBAD]: '悪質ｷｬﾝｾﾙ',
  [STATUS_CANCELOFFICE]: 'ｷｬﾝｾﾙ(店事由)',
  [STATUS_CANCELHIME1]: 'ｷｬﾝｾﾙ(女子事由)',
  [STATUS_CANCELHIME2]: 'ｷｬﾝｾﾙ(女子事由)',
  [STATUS_CANCELMISC]: 'ｷｬﾝｾﾙ(その他)',
};